import {apiFetch, handleResponse, JSON_HEADERS} from "./ApiService";

const ERROR_MESSAGES = {
    fetchFail: 'Failed to test connection',
};

export interface ConnectionTestResponse {
    platformSuccess: boolean;
    adapterSuccess: boolean;
}

export const pingNoAuth = async (): Promise<boolean> => {
    try {
        const resp = await apiFetch("/api/adapter-connection", {method: "GET"});
        if (!resp.ok) {
            return false
        }
        const body = await resp.json();
        return body.status === "OK"
    } catch {
        return false;
    }
};


export const testAdyenConnection = async (merchantId: string): Promise<ConnectionTestResponse> => {
    try {
        const params = new URLSearchParams({
            merchantId: merchantId.toString()
        });

        const response = await apiFetch(`api/adapter-connection/adyen?${params.toString()}`, {
            method: 'GET',
            headers: JSON_HEADERS
        });
        handleResponse(response, ERROR_MESSAGES.fetchFail);
        const data = await response.json();

        return {
            adapterSuccess: data.testMe === 'OK',
            platformSuccess: data.testNotification === 'OK'
        };
    } catch (error) {
        console.error('Error testing Adyen connection:', error);
        return {
            platformSuccess: false,
            adapterSuccess: false
        };
    }
};
